export default {
  title: "User Address",
  subtitle: "Edit user address information",

  addNew: "Add New Address",
  createAddress: "Create Address",
  editAddress: "Update User Address",
  deleteAddress: "Delete Address",
  
  fields: {
    country: "Country",
    city: "City",
    address: "Address Line 1",
    address2: "Address Line 2"
  },
  
  placeholders: {
    country: "Select Country",
    city: "Select City",
    address: "Enter address line 1",
    address2: "Enter address line 2 (optional)"
  },
  
  messages: {
    updateSuccess: "UserAddress updated successfully!",
    updateError: "Error updating user address",
    loadingError: "Error loading user address",
    loading: "Loading user address details..."
  },

  actions: {
    update: "Update Address",
    updating: "Updating...",
    back: "Back"
  },
  
  validation: {
    countryRequired: "Country is required",
    cityRequired: "City is required",
    addressRequired: "Address line 1 is required"
  },
  
  table: {
    user: "User",
    label: "Label",
    type: "Type",
    address: "Address",
    city: "City",
    country: "Country",
    phone: "Phone",
    isDefault: "Default",
    actions: "Actions"
  },
  
  types: {
    home: "Home",
    work: "Work",
    billing: "Billing",
    shipping: "Shipping",
    other: "Other"
  },
  
  statusOptions: {
    active: "Active",
    inactive: "Inactive"
  },
  
  breadcrumbs: {
    userAddress: "User Address",
    edit: "Edit"
  }
};
